module.exports = __webpack_public_path__ + "img/Gen-Z.083b8b99.jpeg";